import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { AutoLogoutService } from '../services/auto-logout.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const autoLogoutService = inject(AutoLogoutService);

    let newReq = req.clone();

    // Response
    return next(newReq).pipe(
        catchError(error => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // Sign out
                authService.signOut();
                // Reload the app
                if (!error.url?.includes('Login.php')) {
                    location.reload();
                }
            }

            if (error instanceof HttpErrorResponse && error.status === 301) {
                // Sign out
                authService.signOut();
                // Reload the app
                if (!error.url?.includes('Login.php')) {
                    location.reload();
                }
            }

            if (
                error instanceof HttpErrorResponse &&
                error.status === 200 &&
                error.error.error.message.includes('Unexpected token')
            ) {
                authService.signOut();
                autoLogoutService.clearTimer();
                router.navigate(['/sign-in']);
            }

            return throwError(error);
        })
    );
};
